/**
 * Global auth storage for external access to apiToken (e.g. from sagas).
 * In-memory only; on full reload the token is rehydrated from localStorage by AuthContext
 * during hydrate, so getAuthToken() is valid after app init when the user had a persisted session.
 */
export const authStorage: {
  token?: string;
} = {};

// Function to update the token
export const updateAuthToken = (token: string): void => {
  authStorage.token = token;
};

// Function to get the current token
export const getAuthToken = (): string | undefined => {
  return authStorage.token;
};

// Function to clear the token
export const clearAuthToken = (): void => {
  delete authStorage.token;
};
